/* One row in a list: artwork, title and a tail that shows duration or an
   equaliser when the row is the record on the platter. */

.row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 16px;
  width: 100%;
  text-align: left;
  color: inherit;
  transition:
    background 0.18s,
    transform 0.2s var(--ease);
}

.row + .row {
  box-shadow: 0 -0.5px 0 rgba(11, 31, 23, 0.05);
}

.row:active {
  transform: scale(0.985);
  background: rgba(255, 255, 255, 0.72);
}

@media (hover: hover) {
  .row:hover {
    background: rgba(255, 255, 255, 0.6);
  }
}

.playing {
  background: var(--accent-soft);
}

.art {
  width: 46px;
  height: 46px;
  border-radius: 11px;
  flex: none;
  overflow: hidden;
  position: relative;
  display: block;
  background: linear-gradient(145deg, #eaf3ee, #dce9e2);
  box-shadow: inset 0 0 0 0.5px rgba(11, 31, 23, 0.06);
}

.art img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.glyph {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: var(--accent-deep);
}

.glyph svg {
  width: 20px;
  height: 20px;
}

.body {
  min-width: 0;
  display: block;
}

.title,
.sub {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title {
  font-size: 14.5px;
  font-weight: 580;
  letter-spacing: -0.015em;
  line-height: 1.25;
}

.sub {
  font-size: 12px;
  color: var(--ink-2);
  margin-top: 2px;
  letter-spacing: -0.01em;
}

/* After the base .title rules, so the override actually wins. */
.playing .title {
  color: var(--accent-deep);
}

.tail {
  font-size: 11.5px;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tail svg {
  width: 16px;
  height: 16px;
}

.eq {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 13px;
}

.eq i {
  width: 2.5px;
  border-radius: 2px;
  background: var(--accent-deep);
  animation: eq 0.9s ease-in-out infinite;
}

.eq i:nth-child(1) {
  height: 55%;
  animation-delay: -0.2s;
}

.eq i:nth-child(2) {
  height: 100%;
  animation-delay: -0.5s;
}

.eq i:nth-child(3) {
  height: 70%;
  animation-delay: -0.8s;
}

@keyframes eq {
  0%,
  100% {
    transform: scaleY(0.35);
  }

  50% {
    transform: scaleY(1);
  }
}
